var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9992 16C31.9992 24.8367 24.8359 32 15.9992 32C7.16328 31.9992 0 24.8359 0 16C0 7.16328 7.16328 0 16 0C24.8367 0 32 7.16328 32 16H31.9992Z",
    fill: "#333D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8955 13.0967C11.9804 13.0968 12.0488 13.1661 12.0488 13.251V23.2461C12.0488 23.331 11.9804 23.4003 11.8955 23.4004H8.76855C8.6836 23.4004 8.61426 23.331 8.61426 23.2461V13.251C8.61426 13.166 8.6836 13.0967 8.76855 13.0967H11.8955ZM19.9473 12.7529C21.8429 12.753 23.7245 14.1265 23.7246 16.874V22.7129C23.7246 23.0905 23.4157 23.3993 23.0381 23.3994H20.9775C20.5999 23.3994 20.2901 23.0905 20.29 22.7129V17.9043C20.29 16.9564 19.5211 16.1875 18.5732 16.1875C17.6254 16.1875 16.8564 16.9564 16.8564 17.9043V22.7129C16.8564 23.0905 16.5466 23.3994 16.1689 23.3994H14.1084C13.7308 23.3993 13.4219 23.0905 13.4219 22.7129V13.7822C13.4221 13.4048 13.7309 13.0958 14.1084 13.0957H16.1689C16.5465 13.0957 16.8562 13.4047 16.8564 13.7822V14.2227C17.5434 13.3328 18.6805 12.7529 19.9473 12.7529ZM10.3311 7.60059C11.4691 7.60069 12.3916 8.52403 12.3916 9.66211C12.3915 10.8001 11.469 11.7225 10.3311 11.7227C9.19299 11.7227 8.27064 10.8001 8.27051 9.66211C8.27051 8.52396 9.19291 7.60059 10.3311 7.60059Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.2bad90f4bcb4115bba1b4ab207f4ef4a.svg";
export { ForwardRef as ReactComponent };